import {CreateOrderResultForPayment} from './makePayment'

export default function getRedirectUrl(order: CreateOrderResultForPayment) {
  const {paymentType, transaction, intent, paymentGatewayUrl} = order

  if (paymentGatewayUrl)
    return {
      url: paymentGatewayUrl,
      post: false
    }

  if (!transaction && !intent) return {}

  if (['orion', 'khipu', 'amipass'].includes(paymentType)) {
    const {publicMeta} = transaction
    return {url: publicMeta.start, post: false}
  }

  if (['webpay', 'webpayCurry'].includes(paymentType)) {
    const {publicMeta} = transaction
    return {url: publicMeta.start, post: true}
  }

  if (
    [
      'kushkiCOPSE',
      'sodexo',
      'edenred',
      'mercadoPagoPSECO',
      'mercadoPagoWalletCO',
      'kushkiWebpay'
    ].includes(paymentType)
  ) {
    const {start} = intent.intentPayload
    return {url: start, post: false}
  }

  return {}
}
